/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, DatePicker, message, Drawer, Form, Upload, Icon } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

const { RangePicker } = DatePicker
// const dateFormat = 'YYYY/MM/DD'
const dateFormat = 'LLL'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			defaultThumbnailFileList: []
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
		this.handleDeleteThumbnail = this.handleDeleteThumbnail.bind(this)
	}

	componentDidMount() {
		const { defaultThumbnailFileList } = this.state
		const { selectedEvent } = this.props
		if (selectedEvent && selectedEvent.thumbnail_url) {
			defaultThumbnailFileList.push({
				uid: selectedEvent.uid,
				name: selectedEvent.name,
				status: 'done',
				url: `${process.env.REACT_APP_BACKEND_API}${selectedEvent.thumbnail_url}`,
				fromServer: true
			})
			this.setState({ defaultThumbnailFileList })
		}
	}

	handleDeleteThumbnail (event_uid) {
		const { deleteThumbnail } = this.props

		message.loading({ key: 'delete_thumbnail', content: 'Deleting thumbnail, please wait..' })
		deleteThumbnail({ event_uid }).then((response) => {
			message.success({ key: 'delete_thumbnail', content: 'Thumbnail successfully deleted.' })
		}).catch(err => {
			console.log('error deleting thumbnail')
			message.error({ key: 'delete_thumbnail', content: err.message.replace('GraphQL error:', '') })
		})
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveEvent, onClose, isEdit, selectedEvent } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			// parse thumbnail file
			const thumbnailfileList = _.has(values.thumbnail, 'fileList') ? values.thumbnail.fileList : []
			const formattedthumbnailFiles = thumbnailfileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const thumbnailfiles = []
			if (formattedthumbnailFiles.length > 0) {
				thumbnailfiles.push(formattedthumbnailFiles[formattedthumbnailFiles.length - 1])
			}
			delete values.thumbnail

			// parse event date
			const from_date = moment(values.event_range[0]).format('YYYY-MM-DD HH:mm:ss')
			const to_date = moment(values.event_range[1]).format('YYYY-MM-DD HH:mm:ss')
			delete values.event_range

			let params = Object.assign({}, values, { barangay_uid, from_date, to_date, thumbnailfiles })
			if (selectedEvent) {
				params = Object.assign({}, params, { event_uid: selectedEvent.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_event', content: 'Saving event, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveEvent(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_event', content: 'Event successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving event')
					message.error({ key: 'set_event', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}

	render() {
		const { defaultThumbnailFileList } = this.state
		const { visible, onClose, form, selectedDate, selectedEvent } = this.props
		const { getFieldDecorator, getFieldValue } = form
		
		const uploadButton = (
			<div>
			  <Icon type={'plus'} />
			  <div className="ant-upload-text">Upload</div>
			</div>
		)

		var that = this
		const thumbnailfileProps = {
			name: 'file',
			multiple: false,
			onChange(info) {
				if (_.isEqual(info.file.status, 'removed')) {
					console.log('file removed', info.file)
					if (_.has(info.file, 'fromServer') && info.file.fromServer) {
						that.handleDeleteThumbnail(info.file.uid)
						that.setState({ defaultThumbnailFileList: [] })
					}
				}
			},
			beforeUpload (file, fileList) { return false },
			showUploadList: true,
			accept: 'image/jpeg, image/png',
			listType: 'picture-card'
		}

		return (
			<Drawer
				title="Manage Event"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'50%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Event Name'>
							{ getFieldDecorator('name', {
								initialValue: (selectedEvent) ? selectedEvent.name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Event Name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: (selectedEvent) ? selectedEvent.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter Remarks'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Select Date Range of Event'>
							{ getFieldDecorator('event_range', {
								initialValue: (!selectedEvent && selectedDate) ? 
								    [moment(new Date(selectedDate), dateFormat), moment(new Date(selectedDate), dateFormat)] : 
								    [moment(new Date(selectedEvent.from_date), dateFormat), moment(new Date(selectedEvent.to_date), dateFormat)],
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<RangePicker 
									showTime
									format={dateFormat}
									separator='to'
									style={{ width: '100%' }}
									disabledDate={this.disabledDate}
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Thumbnail'>
							{ getFieldDecorator('thumbnail', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Upload defaultFileList={defaultThumbnailFileList} {...thumbnailfileProps}>
									{
										((defaultThumbnailFileList.length > 0) || (getFieldValue('thumbnail') && (getFieldValue('thumbnail').fileList.length > 0))) ? null : uploadButton
									}
								</Upload>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_EVENT = gql`
    mutation setEvent($input: JSON) {
		setEvent(input: $input)
    }
`

const DELETE_EVENT_THUMBNAIL = gql`
    mutation deleteThumbnail($input: JSON) {
		deleteThumbnail(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-event' }),
	inject('AuthStore'),
	graphql(SET_EVENT, {
		props({ mutate }) {
			return {
				saveEvent(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allEvents','eventByDate']
					})
				}
			}
		}
	}),
	graphql(DELETE_EVENT_THUMBNAIL, {
		props({ mutate }) {
			return {
				deleteThumbnail(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allEvents','eventByDate']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
